import { HttpClient } from '@angular/common/http';
import { Injectable, TransferState } from '@angular/core';
import { HttpLink } from 'apollo-angular/http';

import { Apollo } from 'apollo-angular';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class PublishersContentService extends BaseGQLService<any> {
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: PublishersContentModel,
        clientName: 'PublishersContentService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: 'queryPublishersContents',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState
    );
  }

  // override document = gql`
  // query RootQuery($filter:String!,$skip:Int, $top:Int)
  // {
  //   ${this.config.rootTypeName}(filter:$filter,skip:$skip, top:$top)
  //   {
  //       ${
  //         this.config.wrapperTypeName
  //           ? `${this.config.wrapperTypeName} { ${this.buildGQLProps()} } ${
  //               this.config.extraProps
  //             }`
  //           : `${this.buildGQLProps()}`
  //       }
  //   }
  // }`;


}

export class PublishersContentModel{
  id:string = '';
  flatData:PublishersContentDetails = new PublishersContentDetails();
}

export class PublishersContentDetails{
  publishername:string = '';

}